module.exports = __webpack_public_path__ + "img/54bda04.png";